import * as types from './incentiveUpdateTypes'

const initialState = {
  incentiveUpdateReasonsList: [],
  isFetching: false,
  incentiveUpdateReasonSelected: null,
  isUpdating: false,
  initialIncentive: null,
  incentive: null,
  timeSlotId: null,
  currency: null
}

export const incentiveUpdateReasonsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INCENTIVE_UPDATE_REASONS_REQUESTED:
      return { ...state, isFetching: true }
    case types.FETCH_INCENTIVE_UPDATE_REASONS_SUCCEEDED:
      return { ...state, incentiveUpdateReasonsList: action.payload, isFetching: false }
    case types.FETCH_INCENTIVE_UPDATE_REASONS_FAILED:
      return { ...state, isFetching: false }
    default:
      return state
  }
}

export const updateIncentiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_INCENTIVE_REQUESTED:
      return { ...state, isUpdating: true, isUpdateSuccessful: false }
    case types.UPDATE_INCENTIVE_SUCCEEDED:
      return { ...state, isUpdating: false, isUpdateSuccessful: true }
    case types.UPDATE_INCENTIVE_FAILED:
      return { ...state, isUpdating: false, isUpdateSuccessful: false }
    case types.RESET_UPDATE_INCENTIVE_STATE:
      return {
        ...state,
        isUpdateSuccessful: false
      }
    default:
      return state
  }
}

export default updateIncentiveReducer
